<!--
共通フッターコンポーネント
TODO: PZとFLP共通で使えるようにしたい
-->
<template>
    <footer class="common">
        <div class="services">
            <p>ＪリーグID利用サービスに戻る</p>
            <ul>
                <li><a href="https://www.jleague-ticket.jp/"><img src="https://auth2.jleague.jp/img/bnrTicket.png" width="216" height="98" id="bnrTicket" alt=""></a></li>
                <li><a href="https://store.jleague.jp/"><img src="https://auth2.jleague.jp/img/bnrStore.png" width="216" height="98" id="bnrStore" alt=""></a></li>
            </ul>
        </div>
        <ul class="subLinks">
            <li><a href="https://auth2.jleague.jp/contents/privacypolicy.html">プライバシーポリシー</a></li>
            <li><a href="https://auth2.jleague.jp/contents/agreement.html">利用規約</a></li>
            <li><a href="https://auth2.jleague.jp/contents/guide.html">よくある質問・お問い合わせ</a></li>
            <li><a href="https://auth2.jleague.jp/contents/accessibility.html">ウェブアクセシビリティについて</a></li>
        </ul>
        <div class="copyrights">
            本サイトで使用している文章・画像等の無断での複製・転載を禁止します。<br>
            <small>&copy;JAPAN PROFESSIONAL FOOTBALL LEAGUE ALL RIGHTS RESERVED.</small>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'JleagueFooter',
}
</script>
